<template>
    <div>
        <el-row>
            <el-col>
                <div class="content">
                    <div class="image-box">
                        <img ref="imageBox" :src="imgSrc" style="display:none"/>
                        <div class="thumb-box" :style="{borderRadius:boxRadius}"></div>
                    </div>
                    <div class="preview-box pull-right">
                        <div>{{$t('commons.preview')}}</div>
                        <div class="ui">
                            <img class="cropped" :style="{borderRadius:boxRadius}" :src="maxCrop" height="100" width="100">
                        </div>
                        <span class="text-muted">100 x 100</span>
                        <div class="ui">
                            <img class="cropped" :style="{borderRadius:boxRadius}" :src="minCrop" height="50" width="50">
                        </div>
                        <span class="text-muted">50 x 50</span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <div class="actions">
                    <input accept="image/jpg, image/jpeg, image/png" id="avatarInput" ref="avatarInput" @change="changeFile" type="file">
                    <div class="zoom-group" :style="zoomStyle">
                        <i class="fa" id="zoom-in" @click="zoomIn">+</i>
                        <i class="fa" id="zoom-out" @click="zoomOut">-</i>
                    </div>
                    <el-button type="primary" size="mini" @click="chooseFile">{{$t('commons.upload')}}</el-button>
                    <el-button type="primary" size="mini" :style="zoomStyle" @click="upload">{{$t('commons.confirm')}}</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Cropper from 'cropperjs';

export default {
    data() {
        return {
            cropper: null,
            maxCrop: null,
            minCrop: null,
            imgSrc: null,
            zoomStyle: "display:none",
            cropOption: {
                autoCrop: false,
                viewMode: 1,
                modal: false
            }
        }
    },
    props: {
        url: {
            type: String,
            required: true
        },
        boxRadius: {
            default: "100%",
            type: String,
            require: false
        }
    },
    watch: {
        url() {
            if(this.url) {
                this.imgSrc = this.url
                this.cropper = new Cropper(this.$refs.imageBox, this.cropOption)
                this.zoomShow()
            }
        }
    },
    methods: {
        chooseFile() {
            this.$refs.avatarInput.click()
        },
        zoomShow() {
            this.cropper.crop()
            let canvas = this.cropper.getCroppedCanvas()
            let src = this.imgSrc;
            if(canvas) {
                src = canvas.toDataURL();
            }
            this.minCrop=src
            this.maxCrop=src
            this.imgSrc =src
        },
        zoomIn() {
            this.cropper.zoom(0.2)
            this.zoomShow();
        },
        zoomOut() {
            this.cropper.zoom(-.2)
            this.zoomShow();
        },
        changeFile() {
            let reader = new FileReader()
            let vue = this
            reader.onloadend = function(e) {
                vue.imgSrc = e.target.result
                vue.$nextTick(function() {
                    if(vue.cropper) {
                        vue.cropper.replace(vue.imgSrc)
                    } else {
                        vue.cropper = new Cropper(vue.$refs.imageBox, vue.cropOption)
                    }
                    vue.zoomShow();
                })
            }
            reader.readAsDataURL(this.$refs.avatarInput.files[0]);
            this.zoomStyle = ""
        },
        upload() {
            if (this.cropper) {
                let img = this.imgSrc;
                img = img.replace(/^data:image\/jpeg;base64,/, "").replace(/^data:image\/jpg;base64,/, "").replace(/^data:image\/png;base64,/, "");

                this.$emit("onUpload", img);
            }
        }
    }
}
</script>

<style>
.content{will-change: "transform, opacity"}
.content .actions{overflow:hidden}
.actions {
    margin-top: 10px;
}
.actions i.fa{
    font-size: 26px;
    margin-left: 2px;
    margin-right: 10px;
    cursor: pointer;
}
.actions .zoom-group{margin-bottom: 10px;}
.actions #avatarInput{display:none}
.content .image-box{
	position:relative;
	display:inline-block;
	height:240px;
	width:240px;
	border:1px solid rgb(219, 216, 216);
	background:#fff;
	overflow:hidden;
	background-repeat:no-repeat;
	/*cursor:move*/
}
.content .image-box .thumb-box{
	position:absolute;
	top:50%;
	left:50%;
	width:220px;
	height:220px;
	margin-top:-110px;
	margin-left:-110px;
	border:1px solid rgb(219, 216, 216);
	border-radius:100%;
	-webkit-box-shadow:0 0 0 1000px rgb(219, 216, 216);
	box-shadow:0 0 0 1000px rgb(219, 216, 216);
}
.content .preview-box{width:110px}
.pull-right {float: right;text-align: center}
.content .preview-box .ui{padding-left:0}
.content .preview-box .ui{padding-top:15px}
.content .preview-box .cropped{border-radius:100%}
.content .preview-box .text-muted{color:gray;font-size:12px}
.group .thumb-box,.enterprise .thumb-box{border-radius:0 !important}
.group .cropped, .cropped{border-radius:0;box-shadow:0px 0px 1px #7E7E7E; }
.fa {font: normal normal normal 14px/1 FontAwesome;}
.cropper-crop-box{display: none}
</style>